if (typeof BSS_B2B != undefined) {
  document.addEventListener("DOMContentLoaded", function () {
    setTimeout(() => {
      function shouldExecuteAction() {
        const customer = BSS_B2B?.shopData?.customer;
        if (!customer?.id) {
          return false;
        }
        return true;
      }

      function handleCartMutation() {
        if (shouldExecuteAction()) {
          const priceCards = document.querySelectorAll(
            "product-card product-price"
          );
          priceCards.forEach((price) => {
            price.style.display = "none";
          });
        }
      }
      handleCartMutation();
    }, 1200);
    
      const observer = new MutationObserver(handleMutations);
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

    function handleMutations(mutationList) {
      for (let item of mutationList) {
        if (item.target.className === "bss-b2b-qb-table") {
          handleCartBlockMutation();
        }
      }
    }

    function handleCartBlockMutation() {
      BSS_B2B.observer.cartSubject.listenCartCheckout();
    }
  });
}
